import React from 'react'
import PropTypes from 'prop-types'
import ExerciseHeader from '@components/ExerciseHeader'
import ExerciseBlock from '@components/ExerciseBlock'
import QuizView from './QuizView'

const Quiz = (props) => {
    const {
        name = '',
        preamble = '',
        image = null,
        questions = [],
        type,
        showPanel,
        onShowPanel,
        onClosePanel,
    } = props

    const quizProps = {
        type,
        questions,
        closePanel: () => onClosePanel(),
    }

    return (
        <div>
            <ExerciseBlock
                name={name}
                onShowPanel={onShowPanel}
                preamble={preamble}
                image={image}
            />

            <ExerciseHeader
                exerciseName={name}
                closePanel={onClosePanel}
                openPanel={showPanel}
                // text={`Det här är ett quiz som berör ämnet ${name}, för att klara av quizet krävs 80% rätt.`}
            >
                <QuizView {...quizProps} />
            </ExerciseHeader>
        </div>
    )
}

Quiz.propTypes = {
    name: PropTypes.string,
    questions: PropTypes.array,
}

export default Quiz
